/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { ExportToGitRepository, GitSyncState, ImportGitRepository } from "./data-contracts";

/**
 * No description
 * @tags space-git
 * @name ImportGitRepository
 * @summary Import a Git repository
 * @request POST:/spaces/{spaceId}/git/import
 * @secure
 */

// @ts-ignore
export const importGitRepository: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {};
  RequestBody: ImportGitRepository;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204;
} = {
  route: "/spaces/{spaceId}/git/import",
  method: "post",
  streaming: false,
  tags: ["space-git"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-git
 * @name ExportToGitRepository
 * @summary Export the to a Git repository
 * @request POST:/spaces/{spaceId}/git/export
 * @secure
 */

// @ts-ignore
export const exportToGitRepository: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {};
  RequestBody: ExportToGitRepository;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204;
} = {
  route: "/spaces/{spaceId}/git/export",
  method: "post",
  streaming: false,
  tags: ["space-git"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Get metadata about the Git Sync provider currently set up on the space.
 * @tags space-git
 * @name GetSpaceGitInfo
 * @summary Get space Git info
 * @request GET:/spaces/{spaceId}/git/info
 * @secure
 */

// @ts-ignore
export const getSpaceGitInfo: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: GitSyncState;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/spaces/{spaceId}/git/info",
  method: "get",
  streaming: false,
  tags: ["space-git"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-git
 * @name DeleteLegacyGitInstallation
 * @summary Remove the legacy Git Sync installation from the space to be able to upgrade it to use the new Git integrations
 * @request DELETE:/spaces/{spaceId}/git/legacy-installation
 * @secure
 */

// @ts-ignore
export const deleteLegacyGitInstallation: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/spaces/{spaceId}/git/legacy-installation",
  method: "delete",
  streaming: false,
  tags: ["space-git"],
  criticalityLevel: "low",
  deprecated: false,
};
